import { TriggerPathType, Category } from '@/ai/utils/types';

export const CATEGORY_TARGET_TRIGGER_TYPE_MAP: Record<
  Exclude<Category, 'rum' | 'cloud'>,
  TriggerPathType
> = {
  business_service: 'serviceInfo',
  application: 'wasInfo',
  host: 'hostInfo',
  host_port: 'hostInfo',
  gpu: 'gpuInfo',
  mig: 'gpuInfo', // MIG는 부모 GPU 디테일로 연계 → gpu와 동일 trigger path
  statefulset: 'statefulSetInfo',
  service: 'serviceDetailInfo', // business_service 카테고리랑 동일하게 사용할 필요 없어서 변경
  replicaset: 'replicaSetInfo',
  pod: 'podInfo',
  node: 'nodeInfo',
  network_device: 'networkDeviceInfo',
  namespace: 'namespaceInfo',
  kafka_cluster: 'kafkaClusterInfo',
  kafka_zookeeper: 'kafkaClusterInfo',
  kafka_broker: 'kafkaBrokerInfo',
  kafka_cluster_topic: 'kafkaTopicInfo',
  kafka_broker_topic: 'kafkaTopicInfo',
  job: 'jobInfo',
  interface: 'networkInterface',
  filesystem: 'hostInfo',
  deployment: 'deploymentInfo',
  database: 'dbInfo',
  daemonset: 'daemonSetInfo',
  cronjob: 'cronJobInfo',
  container: 'containerInfo',
  cluster: 'clusterInfo',
  aws_account: 'awsInfo',
  aws_aurora: 'awsInfo',
  aws_dynamodb: 'awsInfo',
  aws_redshift: 'awsInfo',
  aws_documentdb: 'awsInfo',
  aws_elasticache_cluster: 'awsInfo',
  aws_elasticache_node: 'awsInfo',
  aws_elasticache_serverless: 'awsInfo',
  aws_elasticache_shard: 'awsInfo',
  aws_ec2: 'awsInfo',
  aws_lambda: 'awsInfo',
  aws_lightsail_database: 'awsInfo',
  aws_lightsail_instance: 'awsInfo',
  aws_rds: 'awsInfo',
  aws_s3: 'awsInfo',
  aws_vpc: 'awsInfo',
  aws_dms_replinstance: 'awsInfo',
  aws_dms_task: 'awsInfo',
  azure_virtual_machines: 'azureInfo',
  azure_functions: 'azureInfo',
  azure_blob_storage: 'azureInfo',
  azure_cosmos_db: 'azureInfo',
  azure_cache_for_redis: 'azureInfo',
  azure_cache_for_redis_enterprise: 'azureInfo',
  azure_sql_database: 'azureInfo',
  azure_database_for_mysql: 'azureInfo',
  azure_database_for_postgresql: 'azureInfo',
  oracle: 'dbInfo',
  postgresql: 'dbInfo',
  mysql: 'dbInfo',
  redis: 'dbInfo',
  sqlserver: 'dbInfo',
  java: 'wasInfo',
  dotnet: 'wasInfo',
  python: 'wasInfo',
  nodejs: 'wasInfo',
  process: 'processInfo',
  mongodb: 'dbInfo',
  tibero: 'dbInfo',
  cubrid: 'dbInfo',
  clickhouse: 'dbInfo',
  database_cluster: 'dbInfo',
  altibase: 'dbInfo',
  configmap: 'configMapInfo',
  hpa: 'hpaInfo',
  persistent_volume: 'pvcInfo',
  persistent_volume_claim: 'pvcInfo',
  storage_class: 'namespaceInfo',
  ingress: 'namespaceInfo',
  role: 'namespaceInfo',
  role_binding: 'roleBindingInfo',
  cluster_role: 'clusterRolesInfo',
  cluster_role_binding: 'clusterRolesBindingsInfo',
  service_account: 'serviceAccountsInfo',
  network_object: 'networkObjectInfo',
  url: 'urlMonitoringInfo',
  webserver: 'webserverInfo',
  processDetailInfo: 'processDetailInfo',
  route: 'openshiftRouteInfo',
};
